$.fn.PersonnelRow = function() {
  let self = this
  self.current = undefined
  self.buffering = false
  self.is_transitioning = false;

  self.clicked = function() {
    let next = $(this).next('.person__content')
    if (!$.mlmi.mobile.isMobile) {
      if (self.is_transitioning) {
        self.buffering = $(this)
        return false
      }
      $('.person--opened').removeClass('person--opened')
      if (self.current == undefined) {
        next.slideDown(250, function() {
          self.is_transitioning = false
          if (self.buffering) {
            self.buffering.trigger('click')
            self.buffering = false
          }
        })
        self.is_transitioning = true
        self.current = next
        $(this).addClass('person--opened')
      } else if (self.current.is(next)) {
        self.current.slideUp(250, function() {
          self.is_transitioning = false
          if (self.buffering) {
            self.buffering.trigger('click')
            self.buffering = false
          }
        })
        self.current = undefined
        self.is_transitioning = true
      } else {
        self.is_transitioning = true
        self.current.slideUp(250, function() {
          next.slideDown(250, function() {
            self.is_transitioning = false
            if (self.buffering) {
              self.buffering.trigger('click')
              self.buffering = false
            }
          })
        })
        self.current = next
        $(this).addClass('person--opened')
      }
    }
  }

  return function() {
    self.find('.person').on('click', self.clicked)
    $.mlmi.mobile.add(function() {
      $('.person').removeClass('person--opened')
      $('.person__content').css('display', '')
    }, function() {
      //
    })
    return self
  }()
}
